module.exports = __webpack_public_path__ + "media/svg-new/sign-up 1-839ab286.svg";